module.exports = __webpack_public_path__ + "img/td.7d87c4ed.svg";